export default __webpack_public_path__ + "static/media/chapter7.cc66d3ac.png";